import Swiper from 'swiper';
import { Pagination, Mousewheel } from 'swiper/modules';

export default function initResourceCarousel() {
  const mq = window.matchMedia('(min-width: 1024px)');

  function updateFocusability(swiper) {
    swiper.slides.forEach(slide => {
      const visible = slide.classList.contains('swiper-slide-visible');
      slide.querySelectorAll('a, button').forEach(el => {
        if (visible) {
          el.removeAttribute('tabindex');
        } else {
          el.setAttribute('tabindex', '-1');
        }
      });
    });
  }

  function updateDots(swiper, dotsEl) {
    if (!dotsEl) return;
    dotsEl.classList.toggle('is-hidden', swiper.isBeginning && swiper.isEnd);
  }

  document.querySelectorAll('[data-resource-carousel]').forEach(holder => {
    const dotsEl = holder.querySelector('[data-resource-dots]');

    const originalGroups = Array.from(holder.querySelectorAll('.resource-cards')).map(group => ({
      el: group,
      cards: Array.from(group.querySelectorAll('.resource-card')),
    }));

    const totalCards = originalGroups.reduce((sum, { cards }) => sum + cards.length, 0);

    if (totalCards <= 1) holder.classList.add('is-single');

    let swiper, swiperWrapper;

    function setup() {
      if (mq.matches) return;
      if (totalCards <= 1) return;

      holder.classList.add('swiper');

      swiperWrapper = document.createElement('div');
      swiperWrapper.className = 'swiper-wrapper';
      const wrapper = swiperWrapper;

      originalGroups.forEach(({ cards }) => {
        cards.forEach(card => {
          const slide = document.createElement('div');
          slide.className = 'swiper-slide';
          slide.appendChild(card);
          wrapper.appendChild(slide);
        });
      });

      originalGroups.forEach(({ el }) => el.remove());

      holder.insertBefore(wrapper, dotsEl || null);

      swiper = new Swiper(holder, {
        modules: [Pagination, Mousewheel],
        spaceBetween: 20,
        slidesPerView: 'auto',
        watchSlidesProgress: true,
        mousewheel: { forceToAxis: true },
        pagination: {
          el: dotsEl,
          bulletClass: 'dot',
          bulletActiveClass: 'is-active',
          clickable: true,
          renderBullet(index, className) {
            return `<button type="button" class="${className}" aria-label="Go to slide ${index + 1}"></button>`;
          },
        },
        on: {
          init(s) {
            updateFocusability(s);
            updateDots(s, dotsEl);
          },
          slideChangeTransitionEnd(s) {
            updateFocusability(s);
            updateDots(s, dotsEl);
          },
          breakpoint(s) {
            updateFocusability(s);
            updateDots(s, dotsEl);
          },
          resize(s) {
            updateDots(s, dotsEl);
          },
        },
      });
    }

    function destroy() {
      if (!swiper) return;

      swiper.destroy(true, true);
      swiper = null;

      holder.classList.remove('swiper');

      if (swiperWrapper) {
        swiperWrapper.remove();
        swiperWrapper = null;
      }

      if (dotsEl) {
        dotsEl.innerHTML = '';
        dotsEl.classList.remove('is-hidden');
      }

      originalGroups.forEach(({ el, cards }) => {
        cards.forEach(card => {
          card.querySelectorAll('a, button').forEach(focusable => focusable.removeAttribute('tabindex'));
          el.appendChild(card);
        });
        holder.insertBefore(el, dotsEl || null);
      });
    }

    setup();
    mq.addEventListener('change', () => {
      if (mq.matches) {
        destroy();
      } else {
        setup();
      }
    });
  });
}
